import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener,  OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { SharedService } from '../../Services/shared.service';
import { SECTION,WIDGET } from '../../../models/app-json';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FORMI, PAGEI } from '../../../models/page_config_json';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject,  catchError, of, takeUntil } from 'rxjs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {ErrorStateMatcher} from '@angular/material/core';
import { WIDGET_TYPES, pageTypeCnsts, Default_Pages, PAGE_FORM_TYPES, PAGETYPES } from '../../../constants/proj.cnst';
import { matInputErrorStateMatcher, VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping,  APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS, AppPermissionsPipe } from 'shared-library';
import { PageRearrangeService } from '../services/page-rearrange.service';


@Component({
  selector: "lib-mobi-pages",
  templateUrl: "./mobi-pages.component.html",
  styleUrls: ["./mobi-pages.component.scss"],
  providers: [AppPermissionsPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobiPagesComponent implements OnInit,OnDestroy {

  @ViewChild('pagesContainer') pagesContainer!:ElementRef<HTMLElement>;

  pagesdata!: PAGEI[];
  activePageId: string = "";
  isEditablePageName: boolean = false;
  selectedPageID: any;
  newPageName = '';
  widgetTypes = WIDGET_TYPES;
  activePage: string = "";
  activePagePanel: string = "";
  pageStatus: boolean = false;
  widgetStatus: boolean = false;
  pagePanelStatus: boolean = false;
  selectedPage: PAGEI = { pageId: "", pageName: "", forms: [],applicationId:''};
  selectedSections!: FORMI[];
  sectionStatus:boolean=false;
  sectionState:boolean=false;
  widgetState:boolean = false;
  selectedSection!:SECTION;
  selectedForm:any = {form:'',widgets:[]}
  selectedWidget:any = {widgetId:''}
  formIndex:number = -1;
  applicationId!:any;
  validPageName : boolean = false;
  excludedPageTypes: string[] = Object.keys(Default_Pages);
  pageNameCheck:string = "";
  FormGroup!:FormGroup;
  addPageForm!:FormGroup;
  editPage:boolean=false;
  pageId:any
  pageAlreadyExits:boolean = false;
  queryParamsData:any;
  isPagenameEmpty: boolean = false;
  pageDeleteMessage:any = [];
  activeSpinner:boolean=false;
  errorPage:string = "";
  widgetIndex: number=-1;
  isFormChanged:boolean = false;
  entityData:any[] = [];
  entityForm!:FormGroup;
  editPageEntityData:any;
  entityFormEdit:boolean=false;
  entityFormEditWithValue=false;
  isPageNameExist: boolean = false;
  existingPageName:string = '';
  pageLoading:boolean = false;
  matInputError: ErrorStateMatcher = new matInputErrorStateMatcher();
  page_id!: string;
  defaultPages: Record<string,string> = Default_Pages;
  formTypes: Record<string,string> = PAGE_FORM_TYPES;
  isEntityNameExists:boolean = false;
  entityNameCheck: string = "";
  isPageCreated: boolean= false;
  pagesSheffelInProcess:boolean = false;
  widgetDragActive = false;
  private dragTimeoutId: any;
  destroy$:Subject<void> = new Subject<void>();

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;
  pageTypes = PAGETYPES
  invalidPageTypes: any[] = [];
  copyPageInProgress: boolean = false;
  newPageAdded:boolean = false;
  isDeleteInProcess:boolean = false;

  showPageDetails: boolean = false;
  pageIndex!: number;
  selectedPageName:string = '';

  pageVisible: Record<string, boolean> = {};
  trackByPageId = (_: number, page: any): string => page.pageId;
  onPageVisibilityChange(pageId: any, isVisible: any) {
    this.pageVisible[pageId] = isVisible;
  }


  constructor(private sharedService:SharedService,
    private route: ActivatedRoute, 
    private router: Router,
    private dataService: VlDataService,
    private sharedSrv: SharedService, 
    public dialog: MatDialog,
    private httpService: VlHttpService,   
    private _formBuilder:FormBuilder,
    private toasterSrv:ToastrService,
    private cd: ChangeDetectorRef,
    private appPermissionPipe: AppPermissionsPipe,
    private pageRearrangeService: PageRearrangeService,

    ){
      this.invalidPageTypes = [this.pageTypes.splashScreen,this.pageTypes.loginPage,this.pageTypes.landingPage]
    }

  @HostListener('document:click', ['$event'])
  documentClick(event: Event): void {
   this.onMouseClick();
  }

  ngOnInit(): void {
    this.formbuilder();
    this.pagesdata = [];
    const currentParams = { ...this.route.snapshot.queryParams }
    this.applicationId = currentParams['id'];
    this.pageId = currentParams['pageId'];
    this.subscriptions();
    this.changeSubscribe();
  }



  subscriptions(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.queryParamsData=params;
      this.cd.markForCheck();
    })

    this.sharedService.pages1$.pipe(takeUntil(this.destroy$)).subscribe((pages) => {
      this.pagesdata = pages;
      const applicationData = this.sharedService.getApplicationDataEntire();
      if( applicationData && applicationData['page_ids_list'] && applicationData['page_ids_list'].length > 0 && this.pagesdata.length > 0){
       this.pagesdata =  this.pageRearrangeService.rearrangePages(this.pagesdata,applicationData['page_ids_list'] );
      }
      this.setPageOpener();
      this.pageLoading = false;
      this.cd.markForCheck();
    });

    this.sharedService.getAllPagesRefreshActionTrigger();
    this.sharedService.getAllPagesRefreshAction$.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
      if(value) {
        this.sharedService.getAllPages();
        const applicationData = this.sharedService.getApplicationDataEntire();
      if( applicationData && applicationData['page_ids_list'] && applicationData['page_ids_list'].length > 0 && this.pagesdata.length > 0){
        this.pagesdata = this.pageRearrangeService.rearrangePages(this.pagesdata,applicationData['page_ids_list'] );
      }
      }
    })


    this.sharedService.sidenavContentlistSubject$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.activePageId = value.id;
      if(!value.isActive){
        this.widgetAndFormSelectionStatusReset();
      }
      this.cd.markForCheck();
    });

    // current selected page
    this.sharedService.selectedPageObj$.pipe(takeUntil(this.destroy$)).subscribe((page) => {
      this.selectedPage = page;
      if(this.pagesdata.length < 1){
        this.pagesdata = this.sharedService.getPages();
        const applicationData = this.sharedService.getApplicationDataEntire();
      if( applicationData  && applicationData['page_ids_list'] && applicationData['page_ids_list'].length > 0 && this.pagesdata.length > 0){
       this.pagesdata = this.pageRearrangeService.rearrangePages(this.pagesdata,applicationData['page_ids_list'] );
      }
      }
        this.setPageOpener();
        if(this.newPageAdded){
          setTimeout(() => {
            this.scrollPageIntoView();
            this.newPageAdded = false;
          }, 175);
        }
        if(this.pageId && this.pageId == this.selectedPage.pageId){
          this.selectedPageName = this.selectedPage.pageName;
        }
        this.pageLoading = false;
        this.cd.markForCheck();
      })

    // widget,section selection subscription
    this.sharedService.expansionPanelStatesObj.pipe(takeUntil(this.destroy$)).subscribe((values: any) => {
      if((typeof values.sectionIndex == 'number' && values.sectionIndex < 0) || (typeof values.widgetIndex == 'number' && values.widgetIndex < 0) ){
        return;
      }
      this.pageDetailsSetter(this.selectedPage,false)
      this.widgetIndex=values.widgetIndex;
      const validWidgetIndex = (typeof values.widgetIndex == 'number' && values.widgetIndex != -1)
      this.formIndex=values.sectionIndex;
      if(this.selectedPage){
        this.pagesdata.forEach((page) => {
          if(page.pageId === this.selectedPage.pageId){
            page.open = true;
            page.forms?.forEach((form: FORMI) => {
              form.open = false;
              if(validWidgetIndex)
              {
              form.widgets?.forEach((widget:WIDGET) => {
                widget.open = false;
              })
            }
            })
          }
      })
      }
      this.selectedPage?.forms?.forEach((form: FORMI) => {
        form.open = false;
        if(validWidgetIndex)
        {
        form.widgets?.forEach((widget:WIDGET) => {
          widget.open = false;
        })
      }
      })
      this.pagesdata.forEach((page) => {
        if (page.pageId == values.pageID) {
          page.open = true;

          this.selectedForm = {}
          this.sectionFormRenderer(page,values.pageID,values.sectionIndex,this.selectedPage.forms[values.sectionIndex]);
          if (validWidgetIndex) {
            this.selectedPage.forms[values.sectionIndex].widgets[values.widgetIndex].open =
              true;
              this.widgetStatus = true;

           this.selectedWidget = this.selectedPage.forms[values.sectionIndex].widgets[values.widgetIndex];
              this.sectionStatus = false;
          } else {
            this.selectedPage.forms[values.sectionIndex].widgets.forEach((widget : WIDGET) => {
              widget.open = false;
            });
          }
        } else {
          page.open = false;
        }
        this.activePagePanel = pageTypeCnsts.COMPONENTS;
        this.pagePanelStatus = true;
      });
      this.pageStatus = false;
      this.cd.markForCheck();
    });
  }

  widgetAndFormSelectionStatusReset(){
    if(typeof this.formIndex === 'number' && this.formIndex >= 0){
      this.selectedPage.forms[this.formIndex].widgets.forEach((widget:any) => {
        widget["open"] = false;
      })
    }else if(this.selectedPage?.forms && this.selectedPage?.forms.length > 0){
      this.selectedPage?.forms.forEach((form:any) => {
       if(form){
          form.widgets.forEach((widget:any) => {
            widget["open"] = false;
          })
        }
      })
    }
    this.formIndex = -1;
    this.widgetIndex = -1;
    this.selectedWidget = {}
    this.cd.markForCheck();
  }

  setPageOpener(){
    for (const page of this.pagesdata) {
      page.open = page.pageId === this.selectedPage.pageId;
      if (!page.open) { continue }
      this.pageId = this.selectedPage.pageId;
      const forms = this.selectedPage.forms;
      const isValidindex = typeof this.formIndex === 'number' && this.formIndex >= 0
      const form = isValidindex ? forms[this.formIndex] : forms.find((f: any) => f.formConfig.formType === this.formTypes['section']) || forms[0];
      if(form){
        form['open'] = true;
        if(this.formIndex !== -1 && this.widgetIndex != -1){
          const widget = form ? form.widgets[this.widgetIndex] : null;
          if(widget && ("open" in this.selectedWidget)){
            widget['open'] = true;
          }
        }
      }
      break;
    }
    this.cd.markForCheck();
  }

  formbuilder(){   
   this.addPageForm = this._formBuilder.group({
    name:['', [Validators.required,Validators.minLength(3),Validators.pattern(/^[A-Za-z0-9]([A-Za-z0-9 ()-]*[A-Za-z0-9()])?$/)]],
    description:['']
    })
    this.entityForm = this._formBuilder.group({
      selection:'existing',
      name:['', [Validators.minLength(3),Validators.pattern(/^[A-Za-z0-9]([A-Za-z0-9 -]*[A-Za-z0-9])?$/)], [this.entityNameValidator()]],
      dropDownData:['']
    })
  }

  entityNameValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      const enteredName = control.value;
       this.isEntityNameExists = this.entityData.some(entity => {
        return entity.entity_name?.toLowerCase() === enteredName?.toLowerCase();
      });
      this.entityNameCheck = this.isEntityNameExists ? "Entity name already exists!" : "Entity name available.";
      return of(this.isEntityNameExists ? { entityExists: true } : null).pipe(
        catchError(() => of(null))
      );
    };
  }

  getNameErrorMessage(control:any) {
    const nameFormControl = control;
    if (nameFormControl?.hasError('required')) {
      return 'Please fill the above textfield.';
    }
    if (nameFormControl?.hasError('pattern')) {
      return 'Enter a valid name.';
    }
    if (nameFormControl?.hasError('minlength')) {
      return 'Name must be at least 3 characters.';
    }
    return '';
  }

  isActivePage(pageIndex: number): number {
    return pageIndex;
  }




  subNavValueSetter(page: PAGEI,type:any) {
    this.selectedWidget.open = false;
    if(type != 'modifyPage'){
    this.activePageId = page.pageId ? page.pageId : '';
    this.sharedService.setSidenavContentlistOption('addComponent',true);
    this.sharedService.setWidgetListStatus(true);
    }else{
      this.activePageId = page.pageId ? page.pageId : '';
      this.sharedService.setSidenavContentlistOption('modifyPage',true);
      this.sharedService.setWidgetListStatus(true);
    }
  }
 

  pageDetailsSetter(page: PAGEI,navigate: boolean = true) {
    if(this.pagesSheffelInProcess){
      return;
    }
    this.selectedPageName = page.pageName;
    if(navigate){
      this.pageLoading = true;
      const currentParams = { ...this.route.snapshot.queryParams };
      currentParams["pageId"] = page.pageId;
      this.router.navigate([], {  
        relativeTo: this.route,
        queryParams: currentParams,
        queryParamsHandling: "merge",
      });
    }
      this.sharedService.setShowMenuStatus(false);
      this.pagesdata.forEach((page) => {
        page.open = false;
    })
    this.pageIndex = this.pagesdata.findIndex((p:any) => p.pageId === page.pageId);
    page.open = true;
    this.activePagePanel = pageTypeCnsts.COMPONENTS;
    this.selectedSections = this.selectedPage.forms;
    this.showPageDetails = true;
    this.widgetIndex = -1;
    this.formIndex = -1;
    this.sharedService.setSidenavContentlistOption('',false);
    this.cd.markForCheck();
  }

  getPageById(pageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = {page_id: pageId}
   return this.httpService.placeAPICall(apiConfig);
  }

  pagePanelStatusSetter(activePanelName: string) {
    if (activePanelName !== this.activePagePanel) {
      this.pagePanelStatus = true;
      this.activePagePanel = activePanelName;
    } else {
      this.pagePanelStatus = !this.pagePanelStatus;
    }
  }

 async addPage(template:TemplateRef<any>,type:any,pageId?:any,pageName?:any) {
     this.isPageNameExist = false;
    this.entityForm.reset();
    this.entityData = await this.sharedService.fetchEntity(this.applicationId,'application')
    if(type=='edit'){
      this.editPageEntityData =  await this.sharedService.fetchEntity(pageId,'pageId');
      if (this.editPageEntityData?.length !== 0) {
        this.entityForm.patchValue({
          'selection': 'existing',
          'dropDownData': this.editPageEntityData[0]?.entity_id
        });
        this.entityFormEdit=true;
        this.entityFormEditWithValue=true;
      } else {
        this.entityForm.patchValue({
          'selection': 'new'
        });
        this.entityFormEdit=true;
      }
    }else{
      this.entityForm.patchValue(this.entityData.length !=0 ? {'selection':'existing'}:{'selection':'new'});
      this.entityFormEdit=true;
    }
    this.validPageName = false;
    setTimeout(() => {
      this.isPagenameEmpty = false;
    }, 10);
    this.openModal(template,pageId,pageName,type);
    this.isFormChanged=false;
    this.cd.markForCheck();
  }

  copyPage(pageId:any){
    this.copyPageInProgress = true;
    this.activeSpinner = true;
    this.sharedService.copyPage(pageId,this.queryParamsData['id']).pipe(takeUntil(this.destroy$)).subscribe({
      next:(data:any) => {
        if(data?.newPageId){
          this.pageRearrangeService.updateOrder(this.applicationId,this.pagesdata.map((page:any) => page.pageId), data.newPageId, 'add');
        }
          this.newPageAdded= true;
          this.activeSpinner = false;
          this.copyPageInProgress = false;
          this.toasterSrv.success("Page copied successfully!");
          this.sharedService.getAllPages();
          if(data?.newPageId){
            this.pageDetailsSetter({pageId:data?.newPageId,pageName: data?.newPageName ?? 'copiedPage'});
          }
        },
        error:(error:any) => {
        this.copyPageInProgress = false;
        if(error?.status == 403) {
          this.toasterSrv.error('You do not have permission to access this resource.');
        }
        this.toasterSrv.error("Error while copying the page!");
      }
    }
    )
  }

  scrollPageIntoView(){
    if(this.pagesContainer && this.selectedPage){
      const pageElement = this.pagesContainer.nativeElement.querySelector(`#page-${this.selectedPage?.pageId}`);
      if(pageElement){
        pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  navigateBackToPages(){
    this.showPageDetails = false;
    this.sharedService.setSidenavContentlistOption('',false);
    this.sharedService.setWidgetListStatus(false);
    this.widgetAndFormSelectionStatusReset();
    this.cd.markForCheck();
  }
 
  async deletePage(pageId: any,templateref:any,pageName:string,value:any) {
    this.isDeleteInProcess = true;
    this.page_id=pageId
    this.errorPage = pageName;
    const isDeleted = await this.sharedService.deletePage(pageId,value);
    if(isDeleted.success) {
      this.isDeleteInProcess = false;
      this.handleSuccessfulPageDeletion();
      this.pageRearrangeService.updateOrder(this.applicationId,this.pagesdata.map((page:any) => page.pageId), pageId, 'remove');
      this.toasterSrv.success("Page deleted successfully!");        
    }else{
      this.isDeleteInProcess = false;
        this.pageDeleteMessage = isDeleted.message;
      this.openErrorModal(templateref);
    }
    this.cd.markForCheck();
  }

  openErrorModal(template:TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true
    });
  }
  
  async deletingPage(pageId:any,value:any){
    this.isDeleteInProcess = true
    const isDeleted = await this.sharedService.deletePage(pageId,value);
    if(isDeleted.success) {
      this.handleSuccessfulPageDeletion();
      this.pageRearrangeService.updateOrder(this.applicationId,this.pagesdata.map((page:any) => page.pageId), pageId, 'remove');
      this.toasterSrv.success("Page deleted successfully!");        
      
    }else{
      this.toasterSrv.error('Error while deleting the page!');
    }
    this.isDeleteInProcess = false;
  }

  handleSuccessfulPageDeletion() {
    const currentParams = { ...this.route.snapshot.queryParams };
    currentParams['pageId'] =
      currentParams['pageId'] == this.page_id
        ? this.pagesdata[0]?.pageId
        : currentParams['pageId'];
  
    const index = this.pagesdata.findIndex(
      (item: any) => item.pageId == this.page_id
    );
  
    if (index !== 0) {
      this.router.navigate(['home', 'mobile'], {
        queryParams: {
          id: this.queryParamsData?.id,
          applicationType: this.queryParamsData?.applicationType,
          pageId: this.pagesdata[index - 1]?.pageId,
        },
      });
    }
  
    this.sharedService.setSidenavContentlistOption('', false);
  }

  rearrangeWidgets(event: CdkDragDrop<any>) {
    if(!this.appPermissionPipe.transform([this.appPermissions.editPage,this.permissionsActions.edit])){
      return;
    }
    const formIndex = this.selectedPage.forms.findIndex((form:any) => form.formConfig.formType === pageTypeCnsts.SECTION)
    if(formIndex !== -1){
    moveItemInArray(this.selectedPage.forms[formIndex].widgets, event.previousIndex, event.currentIndex);
    const newIndexInDestination = event.currentIndex;

    if (this.selectedPage.pageType !== pageTypeCnsts.PREVIEW) {
      this.sharedService.updateFormWidgetsRemapCode(this.selectedPage.forms[formIndex].widgets);
    } else {
      this.sharedService.updateFormWidgetsRemapCode(this.selectedPage.forms[formIndex].widgets, this.selectedPage.forms[formIndex].formId);
    }
    }
  }

  rearrangeSection(event: CdkDragDrop<any>) {
    moveItemInArray(
      this.selectedSections,
      event.previousIndex,
      event.currentIndex
    );
    if(this.selectedPage.pageId)
    {
    }
  }
  sectionFormRenderer(page:PAGEI,pageIndex:number,sectionIndex:number,form:any,tempFlag?:any)
  {
    this.selectedWidget.open = false;
    if(form.formId !== this.selectedForm.formId){
      if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL)
      {
        this.sharedService.setShowMenuStatus(true);
      }
      else{
        this.sharedService.setShowMenuStatus(false);
      }
      this.formIndex = sectionIndex;
      this.selectedForm.open = false;
      this.selectedForm = form;
      form.open = true;
      this.sectionStatus = true;
      this.sectionState = false;
    }
    else if(this.formIndex === sectionIndex)
    {
      if(this.sectionState && tempFlag)
      {
        form.open = true;
        if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL)
        {
          this.sharedService.setShowMenuStatus(true);
        }
        this.sectionStatus = true;
        this.sectionState = false;
      }
      else if(!tempFlag){

        form.open = true;
        this.sectionState = true;
      }
      else{
        this.sectionStatus = false;
        form.open = false;
        this.sectionState = true;
        if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL)
        {
          this.sharedService.setShowMenuStatus(false);
        }
      }
     
    }

    if(tempFlag){
      this.sharedService.setSidenavContentlistOption('',false);
    }

  }
 

  widgetFormRenderer(
    page: PAGEI,
    formIndex: number,
    widgetIndex: number,
    widget: WIDGET
  ) {
    if( this.selectedPage.pageType === pageTypeCnsts.PREVIEW && ![this.widgetTypes.navText, this.widgetTypes.navButton].includes(widget.widgetType)){
      return;
    }

    if(widget.widgetId !== this.selectedWidget.widgetId){
      // this.selectedWidget.open = false;
      let previousSelectedWidget = this.selectedPage.forms[formIndex].widgets.find((widget:any) => widget.widgetId === this.selectedWidget.widgetId);
      if(previousSelectedWidget){
        previousSelectedWidget.open = false;
      }
     
    this.sharedService.onMobileScreenDropUpdateData({
      data: widget.widgetId,
      onClick: true,
      sectionIndex: formIndex,
      widgetIndex: widgetIndex,
      widgetMeta: widget,
      });
      this.widgetIndex = widgetIndex;
      this.selectedWidget = widget;
      widget.open = true;
      this.sectionStatus = false;
      this.widgetState = false;
    }
    else if(this.widgetState)
    {
      widget.open = true;
      this.widgetState = false;
      this.sectionStatus = false;
      
    }
    else{
      this.widgetState = true;
      this.sectionStatus = false;
    }
    this.sharedService.setSidenavContentlistOption('widget',true);
}

 

  changeOn(event:MatSlideToggleChange,widgetIndex:number,formIndex:number){

    if(this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enabled){
    this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enabled = event.checked
    }else{
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig['enabled'] = event.checked
    }
    let  widgetPostData = {
      'applicationId': this.applicationId,
      'widgetConfig': this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig,
      'userId' :  JSON.parse(localStorage.getItem('userInfo') as any )?.['userId'],
      'widgetId':this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId,
    }
    this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
    })
    this.sharedService.setSelectedPage(this.selectedPage);
  }

  checkWidgetEnabled(page:any,formIndex:number,widgetIndex:number,widget:any){
    if(widget.widgetConfig?.enabled || widgetIndex <= 1){
      this.widgetFormRenderer(page,formIndex,widgetIndex,widget);
    }
    else{
      this.sharedService.setSidenavContentlistOption('promtStatus',true);
    }
    widgetIndex > 0 ?  this.sharedService.setShowMenuStatus(false) : null
  }

  updateFormData(data: any) {
    this.selectedForm.formLabel = data.label;
    this.selectedForm.formKey = data.key;
    this.selectedForm.formConfig.customStyleApplied = true;
    const formConfig = {...this.selectedForm.formConfig};

    let newformConfig = {...this.selectedForm.formConfing};
    newformConfig.style = {
      backgroundColor: data.bgColor
    }
    this.selectedForm.formConfig = {...formConfig};
    if(this.selectedPage.forms[this.formIndex]?.formConfig){
      this.selectedPage.forms[this.formIndex].formConfig.style = {backgroundColor:data.bgColor};
      this.sharedService.setSelectedPage(this.selectedPage);
    }

  }
  

  updateForm(enableCheck:boolean,event:any)
  { if(enableCheck){
    this.selectedPage.forms[0].formConfig.enable = event.checked;
    }
    let formPostData = {
        formId: enableCheck ? this.selectedPage.forms[0]?.formId : this.selectedForm.formId,
        formLabel: enableCheck ?  this.selectedPage.forms[0]?.formLabel: this.selectedForm.formLabel,
        formKey: enableCheck ? this.selectedPage.forms[0]?.formKey : this.selectedForm.formKey,
        formConfig:this.selectedPage.forms[enableCheck ? 0 : this.formIndex].formConfig, 
        applicationId:this.applicationId              
    }
    this.sharedService.updateForm(formPostData,(enableCheck ? this.selectedPage.forms[0]?.formId : this.selectedForm.formId)).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
    })

    if(!event.checked){
      this.sharedService.setSidenavContentlistOption('',false);
    }
  }

  changeSubscribe(){
    this.addPageForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data:any)=>{
      this.isFormChanged=true;
    });
    this.entityForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data:any)=>{
      this.isFormChanged=true;
    })
    this.entityForm.get('selection')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      const nameControl = this.entityForm.get('name');
      const dropDownDataControl = this.entityForm.get('dropDownData');
      if (value == 'new') {
        if(!this.entityFormEditWithValue){
          this.entityForm.get('dropDownData')?.reset();
        }
      }else {
        this.entityForm.get('name')?.reset();
      }
      nameControl?.updateValueAndValidity();
      dropDownDataControl?.updateValueAndValidity();
    });
  }

  saveEditedPageName(pageID: any,pageName:any){
    this.isEditablePageName = false;
    this.pageNameCheck = "";
    this.entityNameCheck = "";
    let pagePostData = {
      applicationId:this.applicationId,
      pageId : pageID,
      pageName : pageName
    }
    this.sharedSrv.updatePageData(pagePostData as any).pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
     let entityValues = this.entityForm.getRawValue()
     let isNew = entityValues.selection == 'new';
     let isValidName = entityValues.name != null && entityValues.name != ''
     let isValidEntitySelected = entityValues.dropDownData != null;
      if (this.entityFormEditWithValue && !isNew) {
        if (isValidEntitySelected && this.editPageEntityData[0]?.entity_id != entityValues.dropDownData) {
          this.editPageEntityData[0]['removal_page_ids_list'] = [pageID]
          this.sharedService.saveEntiy('edit', this.editPageEntityData[0]).pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            await this.saveEntity(pageID);
          });
        }
        else if (!isValidEntitySelected && this.editPageEntityData[0]['page_ids_list'].includes(pageID)) {
          this.editPageEntityData[0]['removal_page_ids_list'] = [pageID]
          this.sharedService.saveEntiy('edit', this.editPageEntityData[0]).pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
          });
       }
      }
      else if (this.entityFormEditWithValue && isNew && isValidName) {
        this.editPageEntityData[0]['removal_page_ids_list'] = [pageID]
        this.sharedService.saveEntiy('edit', this.editPageEntityData[0]).pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
          await this.saveEntity(pageID);
        });
      } else if (isNew && isValidName) {
        await this.saveEntity(pageID);
      }
      else if (!isNew && isValidEntitySelected) {
        await this.saveEntity(pageID);
      }
      this.closeTemplate();
      this.editPage = false;
      this.sharedSrv.getAllPages()
    },(error:any) => {
      if(error?.status == 403) {
        this.toasterSrv.error('You do not have permission to access this resource.');
      }
      if(error?.error?.result?.includes("already exists")){
        this.pageAlreadyExits = true;
      }
    } 
    )
  }
  
  onPageNameAdd(event:any,editPage:boolean){
    let addPageName: any = this.addPageForm.value.name.trimLeft();    
    addPageName == '' ? this.validPageName = true : this.validPageName = false;
    this.pageAlreadyExits = false;
    this.addPageForm.get('name')?.setValue(addPageName);
    if(this.addPageForm.value.name.trim() !== ""){
      this.isPagenameEmpty = false;
    } else{
      this.isPagenameEmpty = true;
    }
    this.isPageNameExist = this.pagesdata.filter((obj:any) => obj?.pageName?.toLowerCase()?.trim() === event?.target?.value?.toLowerCase()?.trim()).length > 0;
    this.pageNameCheck = this.isPageNameExist ? "Page name already exists!" : "Page name available.";
    if(editPage && this.existingPageName === event?.target?.value?.toLowerCase()?.trim()){
      this.isPageNameExist = false;
      this.pageNameCheck = '';
    }
  }

  onMouseClick(){
    if(this.addPageForm?.value?.name !== null && this.addPageForm?.value?.name?.trim() !== "" ){
      this.isPagenameEmpty = false;
    } else{
      this.isPagenameEmpty = true;
    }
  }
  async createNavBar(data: any) {
    let applicationTheme: any;
    try {
      applicationTheme = await new Promise((resolve, reject) => {
        this.sharedSrv.themesObj.pipe(takeUntil(this.destroy$)).subscribe((theme: any) => {
          resolve(theme);
        }, (error: any) => {
          if(error?.status == 403) {
            this.toasterSrv.error('You do not have permission to access this resource.');
          }
          this.activeSpinner=false;
          reject(error);
        });
      });
      const pageData = await new Promise((resolve, reject) => {
        this.getPageById(data?.pageId).pipe(takeUntil(this.destroy$)).subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            this.activeSpinner=false;
            if(error?.status == 403) {
              this.toasterSrv.error('You do not have permission to access this resource.');
            }
            reject(error);
          }
        );
      });
      await this.sharedService.formatedSectionData(pageData, applicationTheme);
    } catch (error) {
      this.activeSpinner=false;
    }
  }
  
  async savePage(){
    if(!(this.addPageForm.invalid  || (this.isPageNameExist && !this.editPage))){
      this.entityNameCheck = '';
      this.pageNameCheck = '';
      this.activeSpinner=true;
      const currentParams = { ...this.route.snapshot.queryParams };
      let checkpage = ["splashscreen", "login", "landing"].includes(this.addPageForm.value.name.trim().toLowerCase())
      if(!this.editPage ){
        if( this.addPageForm.value.name.trim() !== "" && !checkpage){        
          this.sharedService.addPageData(currentParams['id'],this.addPageForm.value.name.trim().toLowerCase()).pipe(takeUntil(this.destroy$)).subscribe(async(data:any) => {
            this.pageRearrangeService.updateOrder(this.applicationId,this.pagesdata.map((page:any) => page.pageId), data?.pageId, 'add');
            await this.createNavBar(data);
            if((this.entityForm.get('name')?.value != null && this.entityForm.get('name')?.value != "") || this.entityForm.get('dropDownData')?.value != null){
              await this.saveEntity(data?.pageId);
            }
            this.pageDetailsSetter({pageId:data?.pageId,pageName:this.addPageForm?.value.name.trim().toLowerCase() ?? ''});
            this.activeSpinner=false;
            this.closeTemplate();
            this.newPageAdded= true;
          },(error:any) => {
            if(error?.status == 403) {
              this.toasterSrv.error('You do not have permission to access this resource.');
            }
            if(error?.error?.result?.includes("already exists")){
              this.pageAlreadyExits = true;
              this.activeSpinner=false;
            }
          })
        }
        else{
          checkpage ? this.pageAlreadyExits = true : this.validPageName = true;
        }
      }else{
       this.saveEditedPageName(this.pageId,this.addPageForm.getRawValue()?.name)
      }
      this.isPageCreated = true;
    }
  }
  closeTemplate(): void {
    this.addPageForm.reset();
    this.dialog.closeAll();
    this.activeSpinner=false
    this.entityFormEdit=false;
    this.entityFormEditWithValue=false;
  }
  
  openModal(template:TemplateRef<any>,pageId:any,pageName:any,type:any): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,restoreFocus:false
    });
    if(type!='add'){
      this.existingPageName = pageName;
      this.editPage=true;
      this.pageAlreadyExits = false;
      this.pageId=pageId;
      this.pageNameCheck = '';
      this.addPageForm.patchValue({
        name:this.toTitleCase(pageName)
      })
    }else{
      this.editPage = false;
      this.pageAlreadyExits = false;
    }
  }

  onSideNavWidgetDeleteClick(formIndex: number, form: any, widgetId: any, widget: any) {
    if (widget.open) {
      this.sharedSrv.setSidenavContentlistOption('widget', false);
    }
    let currentPageData: any = this.selectedPage;
    let pageSectionList1: any = this.selectedPage?.forms
    if (form.widgets.length > 0) {
      this.sharedSrv.deleteWidget(currentPageData, formIndex, widgetId,widget.widgetConfig['previewPageId'] ?? widget.widgetConfig["dataListViewPageId"]);
      pageSectionList1[formIndex].widgets = (pageSectionList1?.[formIndex]?.widgets || []).filter((widget: any) => widget.widgetId !== widgetId);
    } else {
      this.deleteSection(formIndex, form, currentPageData);
    }
  }

  deleteSection(index: number, section: any, page: PAGEI): void {
    let pageId: any = page?.pageId
    this.sharedSrv.deleteForm(section.formId, page).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.getPageById(pageId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.sharedSrv.setSelectedPage(data);
      })
    });
  }

  slideTiggleChange(event:MatSlideToggleChange,widgetIndex:number,formIndex:number,WidgetId:any){
    if(widgetIndex == 0){
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable = event.checked
      if(event.checked == true){
        this.selectedPage.forms[formIndex].widgets[1].widgetConfig.style['margin-top'] = '40px'
      }else{
        this.selectedPage.forms[formIndex].widgets[1].widgetConfig.style['margin-top'] = '160px'
      }

      let  widgetPostData = {
        'widgetsData':[{
        'widgetId':this.selectedPage.forms[formIndex].widgets[1]?.widgetId,
        'widgetConfig':this.selectedPage.forms[formIndex].widgets[1].widgetConfig
        },{
          'widgetId':this.selectedPage.forms[formIndex].widgets[0]?.widgetId,
          'widgetConfig':this.selectedPage.forms[formIndex].widgets[0].widgetConfig
          }
        ]
      }
      this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      })
      if(!event.checked && this.selectedWidget.widgetId === WidgetId){
        this.sharedService.setSidenavContentlistOption('',false);
      }
      return;
    }

    if(this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable){
    this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable = event.checked
    }else{
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig['enable'] = event.checked
    }
    let  widgetPostData = {
      'applicationId': this.applicationId,
      'widgetConfig': this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig,
      'userId' :  JSON.parse(localStorage.getItem('userInfo') as any )?.['userId'],
      'widgetId':this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId,
    }
    this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
    })
    this.sharedService.setSelectedPage(this.selectedPage);
    if(!event.checked && this.selectedWidget.widgetId === WidgetId){
      this.sharedService.setSidenavContentlistOption('',false);
    }
  }
 async saveEntity(newPageId:any){
  let entityFormValues:any = this.entityForm.getRawValue();
  if(entityFormValues?.selection != 'new'){
    let index = this.entityData.findIndex(item => item.entity_id === entityFormValues?.dropDownData);
      this.entityForm.patchValue({'dropDownData':this.entityData[index]})
      this.entityForm.getRawValue()?.dropDownData?.page_ids_list.push(newPageId);
  }
  entityFormValues = this.entityForm.getRawValue();
    this.sharedService.saveEntiy('add',{},this.applicationId,entityFormValues?.selection =='new' ? entityFormValues?.name.trim() : entityFormValues?.dropDownData ,newPageId).pipe(takeUntil(this.destroy$)).subscribe(async (data:any) => {
    })
  }

  ngOnDestroy(): void {
    this.widgetAndFormSelectionStatusReset();
    this.destroy$.next();
    this.destroy$.complete();
    this.sharedSrv.setPagesExpansionPanelOpener({
      pageID: this.selectedPage.pageId ?? "",
      sectionIndex: -1,
      widgetIndex: -1,
    });
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

//#region page Rearranging
    bodyElement: HTMLElement = document.body;

  drop(event: any) {
     if (this.widgetDragInProgress) {
    return; // Don't process page drop if widget is being dragged
  }
    if (this.widgetDragActive) {
      console.log('Ignoring page drop - widget drag active');
      return;
    }
    if(event.previousIndex > 2 && event.currentIndex > 2){
      moveItemInArray(this.pagesdata, event.previousIndex, event.currentIndex);
      const pageIdsList : string[] = this.pagesdata ? this.pagesdata.map((page: any) => page.pageId) : [];
      this.pageRearrangeService.editApplication(this.applicationId, pageIdsList);
    }
  }

   // Page drag handlers
  private widgetDragInProgress = false;

  onPageDragStarted(): void {
    this.bodyElement.classList.add('inheritCursors');
    this.bodyElement.style.cursor = 'grabbing'; 
     this.selectedPage['open'] = false;
     this.pagesSheffelInProcess = true;
  }

  onPageDragReleased(){
    this.bodyElement.classList.remove('inheritCursors');
    this.bodyElement.style.cursor = 'unset';
     this.pagesSheffelInProcess = false;
  }

  closePage(){
    this.pagesSheffelInProcess = false;
    this.pagesdata.forEach((page) => {
      page.open = false;
    });
    this.pageStatus = true;
  }


// Widget drag handlers
  onWidgetDragStarted(event: any): void {
    this.widgetDragActive = true;
    
    // Disable all page drag operations
    const pageDropList = document.querySelector('.drag-boundary[cdkdroplist]') as HTMLElement;
    if (pageDropList) {
      pageDropList.style.pointerEvents = 'none';
    }
    
    // Clear any existing timeout
    if (this.dragTimeoutId) {
      clearTimeout(this.dragTimeoutId);
    }
  }

  onWidgetDragEnded(event: any): void {
    // Re-enable page drag operations after a delay
    this.dragTimeoutId = setTimeout(() => {
      this.widgetDragActive = false;
      
      const pageDropList = document.querySelector('.drag-boundary[cdkdroplist]') as HTMLElement;
      if (pageDropList) {
        pageDropList.style.pointerEvents = 'auto';
      }
    }, 150);
  }

  // Mouse event handlers for additional control
  onWidgetMouseDown(event: MouseEvent): void {
    // Stop propagation to prevent parent drag from starting
    event.stopPropagation();
  }

  onWidgetAreaMouseDown(event: MouseEvent): void {
    // Mark that we're in a widget area
    this.widgetDragActive = true;
  }

  onWidgetAreaMouseUp(event: MouseEvent): void {
    // Small delay before clearing the flag
    setTimeout(() => {
      if (!this.isDragging()) {
        this.widgetDragActive = false;
      }
    }, 50);
  }


  // Helper method to check if any drag is in progress
  private isDragging(): boolean {
    const draggingElements = document.querySelectorAll('.cdk-drag-dragging');
    return draggingElements.length > 0;
  }

//#endregion

}

